<template>
  <div id="doc-contact-person-info">
    <div id="doc-special-offer-header">
      <div style="margin: 10px 0">
        <p>
          <span class="helping-tag" v-if="isTemplate">Contact Name</span>
          <span v-else>{{ getContactName() }}</span>
        </p>
      </div>
      <div style="margin: 10px 0">
        <p>
          <span class="helping-tag" v-if="isTemplate">Contact Position</span>
          <span v-else>{{ getContactPosition() }}</span>
        </p>
      </div>
      <div style="margin: 10px 0">
        <p>
          <span class="helping-tag" v-if="isTemplate">Agent Name</span>
          <span v-else>{{ agent.name }}</span>
        </p>
      </div>
      <div style="margin: 10px 0">
        <p>
          <span class="helping-tag" v-if="isTemplate">Agent Address</span>
          <span v-else v-html="getAddress()"></span>
        </p>
      </div>
      <div style="margin: 40px 0">
        <p>{{bindIssueDate(specialOfferDetail)}}</p>
      </div>
      <div style="text-decoration: underline; font-weight: 900">
        <p>{{bindData(specialOfferDetail, 'promotion.code', '')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { SPECIAL_OFFER_REF_CODE_TYPE, SPECIAL_OFFER_STATUS, STATUS } from '@/configs/constant'
import { bindData } from '@/helpers'
import { dateFormat } from '@/helpers/datetime'
import { get } from 'lodash'

export default {
  name: 'HeaderInformationComponent',
  props: {
    specialOfferDetail: {
      type: Object,
      default: () => {
        return {
          autoRefCode: STATUS.DISABLE,
          status: SPECIAL_OFFER_STATUS.DRAFT,
          refCode: '',
          refCodeSuffixType: SPECIAL_OFFER_REF_CODE_TYPE.AGENT_NAME,
          hotel: {
            id: '',
            information: {
              code: '',
              name: ''
            },
            salePerson: {
              id: '',
              title: '',
              firstName: '',
              lastName: '',
              position: '',
              email: '',
              updatedAt: ''
            }
          },
          promotion: {
            promotion: {
              id: '',
              code: '',
              detail: '',
              minNight: 0,
              maxNight: 0,
              isEnable: 0,
              updatedAt: 0,
              bookingPeriod: {
                startDate: '',
                endDate: ''
              },
              periodOfStayList: [],
              isEnableAllotment: 0,
              roomTypeList: []
            }
          },
          agentList: [],
          general: {
            startDate: '',
            endDate: '',
            issueDate: '',
            internalNote: '',
            footerMessage: '',
            bodyMessage: ''
          }
        }
      }
    },
    agent: {
      type: Object,
      default: () => {
        return {
          name: '',
          information: {
            address: '',
            country: '',
            emailList: [],
            faxList: [],
            phoneList: [],
            zipCode: ''
          },
          contactPerson: {
            emailList: [],
            firstName: '',
            lastName: '',
            title: '',
            position: ''
          }
        }
      }
    },
    isTemplate: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      bindData
    }
  },
  methods: {
    bindIssueDate: function (specialOffer) {
      const dateStr = get(specialOffer, 'issueDate', '')
      let dateString = ''

      if (dateStr !== '') {
        const date = new Date(dateStr)
        dateString = dateFormat.short(date, 'en')
      }

      return dateString
    },
    getContactName: function () {
      const title = get(this.agent, 'contactPerson.title', '')
      const firstName = get(this.agent, 'contactPerson.firstName', '')
      const lastName = get(this.agent, 'contactPerson.lastName', '')

      const fullName = `${title}${firstName} ${lastName}`
      if (fullName.trim() === '') {
        return '-'
      }

      return fullName
    },
    getContactPosition: function () {
      const position = get(this.agent, 'contactPerson.position', '-')

      return position
    },
    getAddress: function () {
      const contactPerson = get(this.agent, 'contactPerson', {})
      const contactPersonEmailList = get(contactPerson, 'emailList', [])
      const mobileList = get(contactPerson, 'mobileList', [])
      const contactPersonPhone = get(contactPerson, 'phone', '')
      const contactPersonFax = get(contactPerson, 'fax', '')
      const contactPersonMobileList = [ ...mobileList ]

      if (contactPersonPhone !== '') {
        contactPersonMobileList.push(contactPersonPhone)
      }

      const agentInfo = get(this.agent, 'information', {})
      const agentEmailList = get(agentInfo, 'emailList', [])
      const agentPhoneList = get(agentInfo, 'phoneList', [])
      const agentFaxList = get(agentInfo, 'faxList', [])

      const address = get(agentInfo, 'address', '')
      const country = get(agentInfo, 'country', '')
      const zipCode = get(agentInfo, 'zipCode', '')
      const fullAddress = `${address} ${country} ${zipCode}`

      const emailList = (contactPersonEmailList.length > 0) ? contactPersonEmailList : agentEmailList
      const phoneList = (contactPersonMobileList.length > 0) ? contactPersonMobileList : agentPhoneList
      const faxList = (contactPersonFax !== '') ? [ contactPersonFax ] : agentFaxList

      const emailStr = (emailList.length > 0) ? emailList.join(', ') : '-'
      const phoneStr = (phoneList.length > 0) ? phoneList.join(', ') : '-'
      const faxStr = (faxList.length > 0) ? faxList.join(', ') : '-'

      return `${fullAddress} <br>Tel: ${phoneStr} <br>Email: ${emailStr} <br>Fax: ${faxStr}`
    }
  }
}
</script>

<style scoped>
  .helping-tag {
    background-color: #78C0D8;
    color: #ffffff;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 15px;
    font-size: 15px;
  }
</style>
